import { epistemicClass } from "@shared/epistemic";

export function StatusPill({ status }: { status: string }) {
  const kind = epistemicClass(status);
  const cls =
    kind === "live" ? "pill pill-live" : kind === "mock" ? "pill pill-mock" : kind === "conflict" ? "pill pill-conflict" : kind === "verify" ? "pill pill-verify" : "pill pill-dim";
  return <span className={cls}>{status}</span>;
}

export function DemoMark({ show }: { show: boolean }) {
  if (!show) return null;
  return <StatusPill status="DEMO / SYNTHETIC" />;
}
